module.exports = __webpack_public_path__ + "ms-icon-150x150.png?29dc187a28991cd3786d53c207295735";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ms-icon-150x150.png
// module id = 227
// module chunks = 0